import React, { useId } from 'react';

// Brand-gradient filter (funnel) icon — the single filter icon for investor-web.
// Replaces the old MUI FilterAlt/FilterList glyphs and the "Filter" text buttons.
//
// `active` renders a small brand dot at the top-right, preserving the "filters are
// applied" signal the old filled-vs-outline icons used to carry.
//
// useId gives each instance a unique gradient id, so several filter icons can share
// a page without duplicate-id collisions (same pattern as SearchGradientIcon).
//
// Default is 18 to match GridViewGradientIcon / ListViewGradientIcon, which it sits
// directly beside in the Deal Flow toolbars. At the old 15 the two buttons had
// identical 40x44.5 boxes but visibly different glyph sizes, so the pair read as
// misaligned. The art's viewBox is 15, so this scales it 1.2x - the stroke lands at
// 1.2px rather than a crisp 1px, which is the trade for matching the neighbour.
const FilterGradientIcon = ({ size = 18, active = false, style = {} }) => {
  const id = useId();
  const gradientId = `filter_gradient_${id}`;

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex',
        lineHeight: 0,
        ...style,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
      >
        <path
          d="M0.5 0.5H14.5L9.5 6.5V12.5L5.5 14.5V6.5L0.5 0.5Z"
          stroke={`url(#${gradientId})`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id={gradientId}
            x1="-3"
            y1="4"
            x2="11"
            y2="18"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#7852F8" />
            <stop offset="1" stopColor="#84AEF6" />
          </linearGradient>
        </defs>
      </svg>

      {active && (
        <span
          style={{
            position: 'absolute',
            top: -3,
            right: -3,
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: '#7852F8',
          }}
        />
      )}
    </span>
  );
};

export default FilterGradientIcon;
